import { z } from 'zod';
/**
 * Phase B — Globale Büro-Marke (Singleton `OrgBranding`).
 *
 * Speist die App-Chrome (Sidebar-/Login-Footer), die Default-E-Mail-Signatur,
 * das Karten-Label sowie den Default-Dokument-Briefkopf. Pro-Kunde-Overrides
 * (Logo, Farbe, Schrift, Template, Footer, Maildomain) liegen am `Customer`.
 *
 * Das Logo wird NICHT über das PATCH-DTO gesetzt, sondern über einen eigenen
 * Upload-Endpoint — daher `logoPath` nur in der Read-Shape.
 */
export const orgBranding = z.object({
    officeName: z.string(),
    expertLine: z.string(),
    addressLine: z.string(),
    contactLine: z.string(),
    mapLabel: z.string(),
    footerText: z.string(),
    emailSignature: z.string(),
    logoPath: z.string().nullable(),
    primaryColor: z.string().nullable(),
    fontFamily: z.string().nullable(),
    defaultMailDomain: z.string(),
});
const hexColor = z
    .string()
    .trim()
    .regex(/^#[0-9a-fA-F]{6}$/, 'Farbe muss ein Hex-Wert sein, z. B. #1E3A8A.');
export const updateOrgBrandingRequest = z
    .object({
    officeName: z.string().trim().max(200).optional(),
    expertLine: z.string().trim().max(200).optional(),
    addressLine: z.string().trim().max(200).optional(),
    contactLine: z.string().trim().max(200).optional(),
    mapLabel: z.string().trim().min(1).max(80).optional(),
    footerText: z.string().trim().max(200).optional(),
    emailSignature: z.string().trim().max(2000).optional(),
    primaryColor: hexColor.nullable().optional(),
    fontFamily: z.string().trim().max(120).nullable().optional(),
    defaultMailDomain: z.string().trim().max(200).optional(),
})
    .strict();
